/**
 * Wook ScrollSmoother Implementation
 * Creates smooth scrolling effect across the entire site
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait for a brief moment to ensure all DOM elements are fully loaded
  setTimeout(initScrollSmoother, 100);
});

function initScrollSmoother() {
  // Register the necessary GSAP plugins
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  
  // Create the ScrollSmoother instance
  const smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 1.5, // Adjust the smoothness (higher = smoother but slower)
    effects: true, // Enables data-speed and data-lag attributes on elements
    normalizeScroll: true, // Prevents jumps when using mouse wheel
    ignoreMobileResize: true, // More consistent behavior on mobile
    smoothTouch: 0.1, // Light smoothing for touch devices (0 disables on touch)
    onUpdate: self => {
      // You can add custom code here that runs on every scroll update
    },
    onStop: self => {
      // Code that runs when scrolling stops
    }
  });

  // Make ScrollSmoother available globally so other scripts can access it
  window.scrollSmoother = smoother;

  // Add scroll-triggered data-speed attributes to specific elements for parallax effects
  setupParallaxEffects();
}

/**
 * Sets up parallax effects on various elements throughout the site
 */
function setupParallaxEffects() {
  // Example: Hero section elements move at different speeds
  const heroImages = document.querySelectorAll('.fruit-image img');
  heroImages.forEach((img, index) => {
    const direction = index % 2 === 0 ? 1 : -1;
    img.setAttribute('data-speed', (0.8 + (index * 0.1) * direction).toFixed(1));
  });
  
  // Product images parallax effects
  const productContainers = document.querySelectorAll('.product-container img');
  productContainers.forEach((img, index) => {
    img.setAttribute('data-speed', ((index % 3) * 0.15 + 0.85).toFixed(1));
  });
  
  // Text elements smooth reveal
  document.querySelectorAll('h2, h3').forEach(heading => {
    heading.setAttribute('data-speed', '0.92');
  });
}
